module.exports = __webpack_public_path__ + "media/images/about_us-ee1e66b5.png";